import { useEffect, useRef, useState } from 'react';

import { useDevice } from '../../../global/contexts/device/device';
import { useNotice } from '../../../global/contexts/notice/notice';

// Shares plain text only: inside a WebView the page URL is a local asset
// origin (https://localhost), which would be meaningless to the recipient.
export function useShareTask() {
    const { bridge } = useDevice();
    const { notify } = useNotice();
    const [isSharing, setIsSharing] = useState(false);
    const controllerRef = useRef(null);

    useEffect(() => () => controllerRef.current?.abort(), []);

    const share = async (task) => {
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        setIsSharing(true);
        const result = await bridge.share(
            { title: `Tarea #${task.id}`, text: `Mastermind · Tarea #${task.id}: ${task.title}`.slice(0, 500) },
            { signal: controller.signal },
        );
        if (controller.signal.aborted) return;
        setIsSharing(false);
        if (result.ok) notify({ tone: 'success', message: 'Compartido.' });
        else if (result.error.code !== 'CANCELLED') notify({ tone: 'warning', message: result.error.message });
    };

    return { share, isSharing };
}
